import Tooltip from "@mui/material/Tooltip";
import type { JSX, ReactNode } from "react";

interface HintedLabelProps {
  hint: ReactNode;
  children: ReactNode;
}

/**
 * Подпись с всплывающей подсказкой: обёртка нужна Tooltip'у, чтобы было к чему
 * прицепить наведение, и живёт в дизайн-системе, а не в каждом экране.
 */
export function HintedLabel(props: HintedLabelProps): JSX.Element {
  return (
    <Tooltip title={props.hint}>
      <span>{props.children}</span>
    </Tooltip>
  );
}
